module.exports = __webpack_public_path__ + "media/applicants/device_signup_6-fr-7575407d.jpg";